import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.6rem;
  border: 1px solid lightgray;
  background-color: hsl(0, 0%, 93%);
  margin: 1rem 1rem;
  padding: 0.5rem;
`;

const Input = styled.input`
  border-radius: 0.6rem;
  border: none;
  background-color: hsl(0, 0%, 93%);
  flex: 1;
  :focus {
    outline: none !important;
  }
`;

export { Input };

export default Container;
